
class CodeMirrorHelper {
  static wrapSelection (cm, wrapChar, wrapCharAfter, adjustPosition = 0) {
    const doc = cm.getDoc();
    const selection = doc.getSelection();
    const cursor = doc.getCursor();
    if (!wrapCharAfter) {
      wrapCharAfter = wrapChar;
    }

    doc.replaceSelection(`${wrapChar}${selection}${wrapCharAfter}`);

    const endCharPos = cursor.ch + wrapChar.length;
    const startCharPos = endCharPos - selection.length;
    if (adjustPosition > 0) {
      doc.setSelection({ line: cursor.line, ch: endCharPos + adjustPosition });
    } else if (adjustPosition < 0) {
      doc.setSelection({ line: cursor.line, ch: startCharPos + adjustPosition });
    } else {
      doc.setSelection({ line: cursor.line, ch: endCharPos }, { line: cursor.line, ch: startCharPos });
    }

    cm.refresh();
    cm.focus();
  }

  static coverLine (cm, coverText) {
    const doc = cm.getDoc();
    const cursor = doc.getCursor();
    const pos = {
      line: cursor.line,
      ch: 0,
    };
    doc.replaceRange(`${coverText} `, pos, pos);
  }

  static insertText (cm, text) {
    cm.replaceRange(text, cm.getCursor());
  }
}

export default CodeMirrorHelper;
